var retailerResultsTemplate = require('./retailer-search-results.handlebars');
var retailerService = new retailerService();
var Pager = require('./../../shared/components/pager/pagerService');
var retailerPager = new Pager();

$(function () {

    if (!$('#findretailer-search-results-container').length) return;

    //Initialize
    let requestedPageSize = parseInt($('#retailer-pager-page-size').val());
    (Number.isInteger(requestedPageSize))
        ? retailerPager.setPageSize(requestedPageSize)
        : retailerPager.setPageSize(retailerService.options.pageSize);

    $('#findretailer-apply-filters').on('click', function () {
        let $emptyResultMessage = $('#retailer-empty-result-message');
        let isValid = areRetailerFiltersValid();
        if (isValid) {
            retailerPager.setCurrentPage(0);
            getRetailerFilterValues();
            getRetailers();
            $emptyResultMessage.addClass('hidden');
        } else {
            $emptyResultMessage.removeClass('hidden');
            $('#retailer-tiles').empty();
            $('#retailer-pager').addClass('hidden');
        }
    });
});

function getRetailers() {
    retailerService.options.pageSize = retailerPager.getPageSize();
    retailerService.options.page = retailerPager.getCurrentPage();

    $.ajax({
        url: '/api/v1/retailers',
        type: 'POST',
        data: retailerService.options,
        dataType: 'json'
    })
        .done(function (data) {

            var html = retailerResultsTemplate({ retailers: data.data });
            $('#retailer-tiles').html(html);

            retailerPager.update("retailer-pager", "#retailer-pager-container", getRetailers, data.totalPages, data.currentPage);
        });
}

function areRetailerFiltersValid() {
    let zipCodeValue = $('#findretailer-filter-zipcode').val();
    let countyValue = $('#findretailer-filter-county').val();

    //zipCodeValue should be a number if it exists, ignores selected county
    if (zipCodeValue.length > 0 && Number.isInteger(parseInt(zipCodeValue))) {
        return true;
    }

    //if zipcodeValue is undefined, ensure there is a county selected
    if (!zipCodeValue.length && countyValue.length > 0) {
        return true;
    }

    return false;
}

function getRetailerFilterValues() {
    let countyValue = $('#findretailer-filter-county').val();
    let zipCodeValue = $('#findretailer-filter-zipcode').val();
    let onlyVendingMachinesValue = $('#chk-lotto-vending-machines').is(":checked");

    retailerService.options.county = countyValue ? countyValue : "";
    retailerService.options.zipCode = zipCodeValue ? zipCodeValue : "";
    retailerService.options.onlyWithVendingMachines = onlyVendingMachinesValue ? onlyVendingMachinesValue : false;
}

function retailerService(options) {
    var retailerSearchDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 12,
        zipCode: "",
        county: "",
        onlyWithVendingMachines: false
    };

    this.options = $.extend(true, retailerSearchDefaultOptions, options);
}


// WEBPACK FOOTER //
// ./features/find-retailer/find-retailer.js